export default __webpack_public_path__ + "static/media/freeze.e92c5618.svg";